import OUTLETLogo from "../images/OUTLET-logo.svg";
import indexStyles from "../scss/footer-sale.scss";
import { EMAIL_SIGNUP } from "../constants/links";
import { returnsLinks } from "../components/FooterLinks";

const orderStatusUrl = "/account/order-status";
const viewProfileUrl = "/account/view-profile";
const cookieCenterUrl = `${window.location.href.replace(/#cookie-preference-center/g, "")}#cookie-preference-center`;

const footerHtml = data => `
  <div class="SALE NOTLOGGEDIN">
    <div id="footer">
      <style type="text/css">
        ${indexStyles}
      </style>
      <div id="footerCart" class="footerCart">
        <div class="footer-ftue">
          <span class="flag"></span>
          <span class="country"></span> / <span class="language"></span>
        </div>
      </div>
      <div id="footerContent" class="footerContentHome">
        <div class="grid-container">
          <div class="info find-a-store">

            <a data-analyticsLabel="Find An Arc'teryx Store" data-linkid="footer:find-a-store" data-url="outlet.arcteryx.com/stores/find-a-store" href="/stores/find-a-store" ><span class="feature-text">${
              data["$^footer-findArcStore^$"]
            }</span></a>
            <p>${data["$^footer-locateBrandStoreOrPartner^$"]}</p>

            <a data-analyticsLabel="Find A Store" data-linkid="footer:find-a-store" data-url="outlet.arcteryx.com/stores/find-a-store" href="/stores/find-a-store" class="sublink">${
              data["$^FindAStoreBuyNow^$"]
            }</a>
          </div>
          <div class="info customer-form">
            <a data-analyticsLabel="BE THE FIRST TO KNOW" target="_blank" data-linkid="footer:email-signup" data-url="outlet.arcteryx.com${EMAIL_SIGNUP}" href="${EMAIL_SIGNUP}" tabindex="0" style="cursor: pointer">
              <span class="feature-text">${data["$^SignUpTitle^$"]}</span>
            </a>

            <p>${data["$^SignUpBodyCopy2^$"]}</p>

            <a data-analyticsLabel="SIGN UP FOR EMAILS" target="_blank" data-linkid="footer:email-signup" data-url="outlet.arcteryx.com${EMAIL_SIGNUP}" href="${EMAIL_SIGNUP}" tabindex="0" class="sublink" style="cursor: pointer">
              ${data["$^SignUpCta2^$"]}
            </a>
          </div>
          <div class="info customer-service-centre">
            <a data-analyticsLabel="Customer Support Centre" data-linkid="footer:help" data-url="outlet.arcteryx.com/help" href="/help" tabindex="0"><span class="feature-text">${
              data["Customer Support Centre"]
            }</span></a>
            <p>${data["$^footer-newMoreInfoHelp^$"]}</p>
            <a data-analyticsLabel="Find Answers" data-linkid="footer:help" data-url="outlet.arcteryx.com/help" href="/help" tabindex="0" class="sublink">${
              data["$^nav-find-answers^$"]
            }</a>
          </div>
        </div>
        <div class="footerMenu">
          <div class="footerContainer">

            <ul class="logo">
              <li>
                <a data-analyticsLabel="Outlet Logo" data-linkid="footer:logo" data-url="outlet.arcteryx.com" href="/" title="Arc'teryx Outlet"><span>Arc'teryx</span>${OUTLETLogo}</a>
              </li>
            </ul>

            <ul class="contact CN-block">
              <li><a data-analyticsLabel="Arc'teryx Outlet FAQ" data-linkid="footer:faq" data-url="outlet.arcteryx.com/help/faq" href="/help/faq">${
                data["Arc'teryx Outlet FAQ"]
              }</a></li>
              <li><a data-analyticsLabel="Sign Up for Emails" data-linkid="footer:email-signup" data-url="outlet.arcteryx.com${EMAIL_SIGNUP}" href="${EMAIL_SIGNUP}" tabindex="0" class="email__signup is--outlet">${
  data["Sign Up for Emails"]
}</a></li>
              <li><a data-analyticsLabel="Customer Support Centre" data-linkid="footer:help" data-url="outlet.arcteryx.com/help" href="/help">${
                data["Customer Support Centre"]
              }</a></li>
            </ul>

            <ul class="orders CN-block">
            <li>
              <a data-analyticsLabel="Shipping and Delivery" data-linkid="footer:shipping" data-url="outlet.arcteryx.com/help/shipping" href="/help/shipping">${
                data["Shipping & Delivery"]
              }</a>
            </li>
            <li>
              <a data-analyticsLabel="Order Tracking" data-linkid="footer:order-status" data-url="outlet.arcteryx.com${orderStatusUrl}" href="${orderStatusUrl}" class="isLoggedIn">${
  data["Order Tracking"]
}</a>
              <a data-analyticsLabel="Order Tracking" data-linkid="footer:order-tracking" data-url="outlet.arcteryx.com/help/order-tracking" href="/help/order-tracking" class="notLoggedIn">${
                data["Order Tracking"]
              }</a>
            </li>
            ${returnsLinks(data, "outlet")}
            </ul>

            <ul class="faq">
              <li><a data-analyticsLabel="Product Care" data-linkid="footer:product-care" data-url="outlet.arcteryx.com/help/product-care" href="/help/product-care">${
                data["Product Care"]
              }</a></li>
              <li><a data-analyticsLabel="Sizing and Fit Guide" data-linkid="footer:sizing" data-url="outlet.arcteryx.com/help/sizing" href="/help/sizing">${
                data["Sizing & Fit Guide"]
              }</a></li>
              <li><a data-analyticsLabel="Product Service" data-linkid="footer:product-service" data-url="outlet.arcteryx.com/help/product-service" href="/help/product-service">${
                data["Product Service"]
              }</a></li>
            </ul>

            <!--////////// SOCIAL ///////////-->
            <div class="social">
              <div class="footer-ftue">
                <a data-analyticsLabel="My Account" data-linkid="footer:my-account" data-url="outlet.arcteryx.com/account/view-profile" class="account logOut CN-block" href="${viewProfileUrl}">${
  data["My Account"]
}</a>
                <a data-analyticsLabel="Sign-In" data-linkid="footer:account-login" data-url="outlet.arcteryx.com/account/login" class="logIn CN-block" href="/account/login">${
                  data["Sign-In"]
                }</a>
                <div class="footer-ftue">
                  <span class="flag"></span>
                  <span class="country"></span> / <span class="language"></span>
                </div>
              </div>

              <div class="social-wrap">
                <ul>
                  <li>
                    <a data-analyticsLabel="Facebook" data-linkid="footer:facebook" data-url="www.facebook.com/arcteryx" href="//www.facebook.com/arcteryx" class="social-na facebook" target="_blank" title="Facebook" rel="noopener">
                      <span class="footer__social-share">Facebook</span>
                    </a>
                  </li>
                  <li>
                    <a data-analyticsLabel="Instagram" data-linkid="footer:instagram" data-url="instagram.com/arcteryx" href="//instagram.com/arcteryx" class="social-na instagram" target="_blank" title="Instagram" rel="noopener">
                      <span class="footer__social-share">Instagram</span>
                    </a>
                  </li>
                  <li>
                    <a data-analyticsLabel="Twitter" data-linkid="footer:twitter" data-url="twitter.com/arcteryx" href="//twitter.com/arcteryx" class="social-na twitter" target="_blank" title="Twitter" rel="noopener">
                      <span class="footer__social-share">Twitter</span>
                    </a>
                  </li>
                  <li>
                    <a data-analyticsLabel="Pinterest" data-linkid="footer:pinterest" data-url="www.pinterest.com/arcteryx" href="//www.pinterest.com/arcteryx" class="social-na pinterest" target="_blank" title="Pinterest" rel="noopener">
                      <span class="footer__social-share">Pinterest</span>
                    </a>
                  </li>
                  <li>
                    <a data-analyticsLabel="YouTube" data-linkid="footer:youtube" data-url="www.youtube.com/arcteryxequipmentinc" href="//www.youtube.com/arcteryxequipmentinc" class="social-na youtube" target="_blank" title="Youtube" rel="noopener">
                      <span class="footer__social-share">YouTube</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;">
          <!-- // -->
        </div>
        <div class="bottom-bar">
          <ul class="site-services">
            <li>
            <a id="preference-center" data-analyticsLabel="Cookie Preference Centre" data-linkid="footer:cookie-preference-center" data-url=${cookieCenterUrl}>${
  data["Cookie Preference Centre"]
}</a> <span class="footer-separator">|</span>
            <a data-analyticsLabel="Cookie Policy" data-linkid="footer:cookies" data-url="outlet.arcteryx.com/help/cookies" href="/help/cookies">${
              data["Cookie Policy"]
            }</a> <span class="footer-separator">|</span>
            <a data-analyticsLabel="Privacy Policy" data-linkid="footer:privacy" data-url="outlet.arcteryx.com/help/privacy" href="/help/privacy">${
              data["Privacy Policy"]
            }</a> <span class="footer-separator">|</span>
            <a data-analyticsLabel="CA Supply Chains Act" data-linkid="footer:ca-supply-chains-act" data-url="outlet.arcteryx.com/help/ca-supply-chains-act" href="/help/ca-supply-chains-act" class="US-only">${
              data["CA Supply Chains Act"]
            }</a>
            <span class="footer-separator US-only"> | </span>
            <a data-analyticsLabel="Terms and Conditions" data-linkid="footer:terms-and-conditions" data-url="outlet.arcteryx.com/help/terms-and-conditions" href="/help/terms-and-conditions">${
              data["Terms & Conditions"]
            }</a> <span class="footer-separator">|</span>
            <a data-analyticsLabel="Terms of Use" data-linkid="footer:terms-of-use" data-url="outlet.arcteryx.com/help/terms-of-use" href="/help/terms-of-use">${
              data["Terms of Use"]
            }</a> <span class="footer-separator">|</span>
            <a data-analyticsLabel="Accessibility" data-linkid="footer:accessibility" data-url="outlet.arcteryx.com/help/accessibility" href="/help/accessibility">${
              data.Accessibility
            }</a> <span class="footer-separator">|</span>
            <a data-analyticsLabel="Do Not Sell My Personal Information" data-linkid="footer:do-not-sell-my-personal-information" data-url="outlet.arcteryx.com/help/privacy#do-not-sell-my-personal-information" href="/help/privacy#do-not-sell-my-personal-information">${
              data["Do Not Sell My Personal Information"]
            }</a>
            </li>
            <li class="footWebsiteList websiteSelector">
            <select title="Please select a website." class="WebsiteSelector">
              <option value="" data-translation="footer-option-selectWebsite" aria-label="Please select a website."
                title="Please select a website.">Please select a website.</option>
              <option class="outdoor" value="https://arcteryx.com/" selected="selected" aria-label="arcteryx" title="arcteryx">Arcteryx.com</option>
              <option class="blog" value="https://blog.arcteryx.com" aria-label="blog" title="blog">blog.arcteryx.com</option>
              <option class="leaf" value="https://leaf.arcteryx.com/" data-translation="footer-option-leaf"
                aria-label="law enforcement and armed forces" title="law enforcement and armed forces">LEAF</option>
              <option class="rocksolid" value="https://www.usedgear.arcteryx.com/" data-translation="footer-option-usedgear"
                aria-label="usedgear" title="usedgear">usedgear.arcteryx.com</option>
            </select>
            </li>
          </ul>
          <ul class="sites">
            <li class="outdoor" data-value="//arcteryx.com"><a data-analyticsLabel="arcteryx.com" data-linkid="footer:arcteryx" data-url="arcteryx.com" href="//arcteryx.com" target="_blank" rel="noopener">arcteryx.com</a></li>
            <li class="sale selected" data-value="//outlet.arcteryx.com">outlet.arcteryx.com</li>
            <li class="blog" data-value="//blog.arcteryx.com"><a data-analyticsLabel="blog.arcteryx.com" data-linkid="footer:blog" data-url="blog.arcteryx.com" href="//blog.arcteryx.com" target="_blank" rel="noopener">blog.arcteryx.com</a></li>
            <li class="leaf" data-value="//leaf.arcteryx.com/"><a data-analyticsLabel="leaf.arcteryx.com" data-linkid="footer:leaf" data-url="leaf.arcteryx.com" href="//leaf.arcteryx.com/" target="_blank" rel="noopener">leaf.arcteryx.com</a></li>
            <li class="AT-block BE-block CZ-block DK-block FI-block FR-block DE-block GB-block IE-block IT-block NO-block PL-block ES-block SE-block CH-block NL-block GB-block" data-value="//www.regear.arcteryx.com"><a data-analyticsLabel="regear.arcteryx.com" data-linkid="footer:regear" data-url="www.regear.arcteryx.com" href="https://www.regear.arcteryx.com/" target="_blank" rel="noopener">regear.arcteryx.com</a></li>
          </ul>
          <ul class="sites">
            <li data-value="//www.amersports.com/">Arc’teryx - an <a class="bottom-bar-amer" data-analyticsLabel="Amer Sports" data-linkid="footer:amer" data-url="https://www.amersports.com/" href="https://www.amersports.com/" target="_blank" rel="noopener" >Amer Sports</a> Brand</li>
          </ul>
        </div>
      </div>
    </div>
  </div>`;

export default footerHtml;
